import styled, { css } from 'styled-components'
import dynamic from 'next/dynamic'
import FormFieldHidden from 'src/form/fields/FormFieldHidden'

import FormikForm from '../../form/FormikForm'
import { mq, sizes } from '../../theme'
import FormSubmitButton from '../../form/FormSubmitButton'
import Link from '../../components/Link'
import { type FormFieldAutoSuggestProps } from '../../form/fields/FormFieldAutoSuggest'

const FormFieldAutoSuggest = dynamic(
  () => import('../../form/fields/FormFieldAutoSuggest')
)

export const Filters = styled.div``
export const Form = styled(FormikForm)``
export const HiddenField = styled(FormFieldHidden)``

export const Grid = styled.div<{
  $department?: Omit<FormFieldAutoSuggestProps, 'name'>
}>`
  @media ${mq(null, sizes.tablet)} {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  @media ${mq(sizes.tablet)} {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 3rem;
    grid-row-gap: 3.7rem;
  }

  @media ${mq(sizes.scoping)} {
    grid-column-gap: 10rem;
  }
`

export const Fields = styled.div`
  display: flex;
  gap: 7rem;

  @media ${mq(null, sizes.tablet)} {
    gap: 3rem;
    flex-direction: column;
  }
`

export const FieldsWrapper = styled.div`
  @media ${mq(sizes.tablet)} {
    display: flex;
    align-items: flex-end;
  }
`

export const OfferTypeBlock = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 1 / 1 / 2 / 3;
    align-self: start;
  }
`

export const SpecialitiesBlock = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 1 / 3 / 2 / 5;
    align-self: start;
  }
`

export const DepartmentBlock = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 1 / 5 / 2 / 7;
    align-self: start;
  }
`

export const LocalisationAndRadiusWrapper = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 1 / 5 / 2 / 7;
    align-self: start;
  }
  .FormFieldInput {
    flex-flow: initial;
  }
`

export const PeriodBlock = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 2 / 1 / 3 / 4;
    align-self: start;
  }
`

export const PeriodBlockControl = styled.div`
  display: flex;
  align-items: center;
  gap: 2ch;
  ${({ theme }) => theme.textStyles.firaSansLg};
  color: ${({ theme }) => theme.colors.bluePrimary};

  > * {
    flex-grow: 1;
  }
`

export const DaysBlock = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 2 / 4 / 3 / 7;
    align-self: start;
  }
`

export const RadiusBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  gap: 1rem;
  flex-wrap: wrap;

  .react-select__single-value {
    color: ${({ theme }) => theme.colors.blueSecondaryBis};
  }

  .react-select__control--menu-is-open {
    .react-select__single-value {
      color: ${({ theme }) => theme.colors.pureWhite};
    }
  }

  .react-select__option {
    > div {
      padding-left: 0;
    }
  }
`

export const LocalizationBlock = styled.div``

export const AutoSuggestField = styled(FormFieldAutoSuggest)``

export const TermeBlock = styled.div<{ $showPeriodAndDays?: boolean }>`
  @media ${mq(sizes.tablet)} {
    grid-area: 2 / 1 / 3 / 5;
  }

  ${({ $showPeriodAndDays }) =>
    $showPeriodAndDays &&
    css`
      @media ${mq(sizes.tablet)} {
        grid-area: 3 / 1 / 4 / 5;
      }
    `}
`

export const BlockTitleWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2ch;
`

export const BlockTitle = styled.span`
  display: inline-block;
  ${({ theme }) => theme.textStyles.firaSansLg};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 3rem;
  position: relative;

  &:after {
    content: '';
    display: inline-block;
    width: 30%;
    position: absolute;
    bottom: -0.5rem;
    left: 0;
    border-bottom: 0.2rem solid ${({ theme }) => theme.colors.bluePrimary};
  }
`

export const BlockHelp = styled.small`
  ${({ theme }) => theme.textStyles.firaSans2XsItalic};
  color: ${({ theme }) => theme.colors.bluePrimary};
`

export const RadiusBlockTitle = styled.span`
  ${({ theme }) => theme.textStyles.firaSansTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const SubmitBlock = styled.div`
  @media ${mq(sizes.tablet)} {
    grid-area: 2 / 3 / 3 / 4;
    justify-self: flex-end;
    align-self: flex-end;
  }
`

export const Wrapper = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    justify-content: space-between;
    flex-direction: row;
  }
`

export const RemoveFilters = styled(Link)`
  ${({ theme }) => theme.textStyles.firaSansTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  text-decoration: underline;
`

export const Submit = styled(FormSubmitButton)``
